export default __webpack_public_path__ + "static/media/30.9d155b2b.jpg";